module.exports = __webpack_public_path__ + "img/farming_10.7342bd99.png";